<div *cftI18n="let t" (click)="toggleShowBreakdown()" class="cursor-pointer">
  <div class="flex justify-start">
    @if (offering.icon) {
      <div class="text-xl md:text-3xl">
        <cft-dynamic-icon [icon]="offering.icon"></cft-dynamic-icon>
      </div>
    }
    <div class="w-full" [class.ml-lg]="offering.icon">
      <div class="text-sm font-semibold md:text-md">
        @if (numberOfItems) {
          <span>{{ numberOfItems }} x</span>
        }
        {{ offering.label }}
      </div>
      <div class="mt-xs flex flex-wrap justify-between gap-2xs">
        <div class="text-xs md:text-base">
          {{ t('clientPriceRangeCard.expectedPrice') }}
        </div>
        @if (priceRange.fromAmount && priceRange.toAmount) {
          <div class="flex items-center">
            <div class="rounded-1 bg-purple-500 px-xs text-xs text-white md:text-sm">
              {{ priceRange.fromAmount | bgoRappenToFranc | currency: 'CHF' : 'code' : '2.0-0' }}
              {{ t('clientPriceRangeCard.priceTo') }}
              {{ priceRange.toAmount | bgoRappenToFranc | currency: 'CHF' : '' : '2.0-0' }}
            </div>
          </div>
        } @else {
          @if (!priceRange.freeOfCharge) {
            <div class="flex items-center rounded-1 bg-grey-200 px-xs text-xs text-grey-500 md:text-sm">
              {{
                priceRange.containUnknowns
                  ? t('clientPriceRangeCard.priceUnknown')
                  : t('clientPriceRangeCard.notSpecified')
              }}
            </div>
          } @else {
            <div class="flex items-center rounded-1 bg-green-500 px-xs text-xs text-white md:text-sm">
              {{ t('clientPriceRangeCard.free') }}
            </div>
          }
        }
      </div>
      @if (infoText) {
        <cft-price-range-info class="mt-xl" [infoText]="infoText"></cft-price-range-info>
      } @else {
        @if (priceRange.containUnknowns) {
          <cft-price-range-info
            class="mt-xl"
            [infoText]="
              priceRange.fromAmount
                ? t('clientPriceRangeCard.containUnknownsTextClient') || ''
                : t('clientPriceRangeCard.priceIncalculableHint') || ''
            "
          ></cft-price-range-info>
        }
      }
      @if (showBreakdown && priceRange.percentageBreakdown.serviceCosts) {
        <cft-price-breakdown class="mt-xl" [breakdown]="priceRange.percentageBreakdown"> </cft-price-breakdown>
      }
    </div>
  </div>
</div>
